import axiosClient from "@/api/common/axiosClient.ts";

type Success = {
  success: true;
  ticket_count: number;
};

type Redirect = {
  redirect_url: string;
  expires_at: string;
};

export const buyTicket = ({
  id,
  count,
}: {
  id?: string | number;
  count: number;
}) => {
  return axiosClient.post<Success | Redirect>(`draws/${id}/buy_tickets/`, {
    count,
  });
};

export const subscribeTicket = ({
  lotteryId,
  count,
}: {
  lotteryId?: string | number;
  count: number;
}) => {
  return axiosClient.post<Success | Redirect>(`subscriptions/subscribe/`, {
    ticket_count: count,
    lottery_id: lotteryId,
  });
};

export const retryPayment = ({ id }: { id: number }) => {
  return axiosClient.post<Success | Redirect>(`subscriptions/${id}/payment/`);
};

export type BuyTicketErrorType = string[] | unknown;
